import AppLayout from "@/components/app-layout";
import SuppliesView from "@/pages/app-supplies";
import { usePageTitle } from "@/hooks/use-page-title";

export default function AppSuppliesPage() {
  usePageTitle("Supplies");
  return (
    <AppLayout>
      <SuppliesView />
    </AppLayout>
  );
}
